import script from "./JobsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsPage.vue?vue&type=script&setup=true&lang=js"

import "./JobsPage.vue?vue&type=style&index=0&id=59c71c83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59c71c83"]])

export default __exports__